<template>
    <div v-if="voya" class="fdl-row">
        <span class="fdl-icon"><span class="material-symbols-outlined">{{ iconName }}</span></span>
        <div class="fdl-main">
            <a v-if="canPreview" class="fdl-name" href="#void" @click.prevent="menuItemClick('preview', document, getType, isDocumentFormat)">{{fileName}}</a>
            <a v-else-if="cannotPreview && isDocumentFormat && canDownload" class="fdl-name" href="#void" @click.prevent="menuItemClick('download', document, 'downloadFormatted')">{{fileName}}</a>
            <a v-else-if="cannotPreview && canDownload" class="fdl-name" href="#void" @click.prevent="menuItemClick('download', document, 'view')">{{fileName}}</a>
            <span v-else class="fdl-name fdl-name-plain">{{fileName}}</span>
            <span class="fdl-size">{{ size | prettyBytes }}</span>
        </div>
        <button v-if="isActive && showDropdown && menuItems.length" type="button" class="fdl-menu-btn" aria-label="Seçenekler" @click.stop="sheetOpen = true">
            <span class="material-symbols-outlined">more_vert</span>
        </button>
        <bottom-sheet v-if="sheetOpen" :title="fileName" @close="sheetOpen = false">
            <button v-for="m in menuItems" :key="m.label" type="button" class="fdl-sheet-item" @click="sheetItemClick(m)">
                <span class="material-symbols-outlined">{{ m.icon }}</span>
                <span>{{ m.label }}</span>
            </button>
        </bottom-sheet>
    </div>
    <fieldset v-else ref="focusObject" @focusout="hideContextMenu">
        <a v-if="isActive  && showDropdown" href="#void" @click.prevent="showContextMenu" class="btn btn-sm btn-light" style="padding: 0 2px; margin-right: 6px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>
        </a>
        <a v-if="canPreview  && !customStyle" class="fileName" href="#void" @click.prevent="menuItemClick('preview', document, getType, isDocumentFormat)">{{fileName}}</a>
        <a v-else-if="cannotPreview && isDocumentFormat && canDownload" class="fileName" href="#void" @click.prevent="menuItemClick('download', document, 'downloadFormatted')">{{fileName}}</a>
        <a v-else-if="cannotPreview && !customStyle && canDownload" href="#void" @click.prevent="menuItemClick('download', document, 'view')">{{fileName}}</a>
        <a v-else-if="customStyle && cannotPreview" ref="customClick" class="customStyle" :class="{'isPreviewing' : isPreviewing}" @click.prevent="menuItemClick('cannotPreview', document, getType, isDocumentFormat)"><span class="mr-2" v-html="getIcon()"></span>{{fileName}}</a>
        <a v-else-if="customStyle" ref="customClick" class="customStyle" :class="{'isPreviewing' : isPreviewing}" @click.prevent="menuItemClick('preview', document, getType, isDocumentFormat)"><span class="mr-2" v-html="getIcon()"></span>{{fileName}}</a>
        
        <span v-else>{{fileName}}</span>
        
        <div v-if="isActive  && showDropdown" @mousedown="disableFocusOut = true" class="dropdown-menu" :class="{ show: isContextMenuVisible }" style="left:auto; top:auto;">
            <a v-if="canDownload" class="dropdown-item" href="#void" @click.prevent="menuItemClick('download', document, 'download')">Orijinal Dosyayı İndir</a>
            <a v-if="hasSignedVersion && canDownload" class="dropdown-item" href="#void" @click.prevent="menuItemClick('download', document, 'downloadSigned')">İmzalı Versiyonu İndir</a>
            <a v-if="hasFormattedVersion && canDownload" class="dropdown-item" href="#void" @click.prevent="menuItemClick('download', document, 'downloadFormatted')">Excel Formatında İndir</a>
            <!-- <div v-if="isEYP || isOffice365 || isGoogleDocs" class="dropdown-divider"></div> -->
            <div v-if="isEYP" class="dropdown-divider"></div>
            <a v-if="isEYP" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'eyp')">EYP paketi görüntüle</a>
            <a v-if="isOffice" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'office')">Dokümanı görüntüle</a>
            <a v-if="isText" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'text')">Metin Belgesini görüntüle</a>
            <a v-if="isCode" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'code')">XML Dosyasını görüntüle</a>
            <a v-if="isPdf" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'pdf',false,true)">Dokümanı görüntüle</a>
            <a v-if="isImage" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'image')">Resmi görüntüle</a>
            <!-- <a v-if="isPdf && hasSignedVersion" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'pdf')">İmzalı PDF Dosyasını görüntüle</a> -->
            <!-- <a v-if="isOffice365" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'office365')">Office365 ile görüntüle</a>
            <a v-if="isGoogleDocs" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'googleDocs')">Google Docs ile görüntüle</a> -->
        </div>
        <!-- <input type="text" ref="focusObject" id="focusObject" class="focus-object"  /> -->
    </fieldset>
</template>
<script>
import BottomSheet from "./Voya/BottomSheet.vue";

export default {
    components: {
        BottomSheet
    },
    props: {
        // true ise Voya satır görünümü ve alttan açılan menü kullanılır
        voya: {
            type: Boolean,
            default: false
        },
        document: {
            type: Object,
            required: true
        },
        isActive: {
            type: Boolean,
            default: true
        },
        isOnlineView: {
            type: Boolean,
            default: true
        },
        isDocumentFormat:{
            type: Boolean,
            default: false
        },
        showDropdown:{
            type: Boolean,
            default: true
        },
        customStyle:{
            type: Boolean,
            default: false
        },
        isPreviewing:{
            type: Boolean,
            default: false
        }

    },
    data(){
        return {
            isContextMenuVisible: false,
            sheetOpen: false,
            disableFocusOut: false,
            documentIndex: null,
        }
    },
    methods: {
        getIcon(){
            var type = this.getType
            if(type == 'pdf'){
                return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"> <path d="M4.82173 28V18.5455H8.55185C9.26894 18.5455 9.87985 18.6824 10.3846 18.9563C10.8893 19.2272 11.274 19.6042 11.5387 20.0874C11.8065 20.5675 11.9403 21.1214 11.9403 21.7493C11.9403 22.3771 11.8049 22.9311 11.5341 23.4112C11.2633 23.8913 10.8709 24.2653 10.3569 24.533C9.846 24.8008 9.22739 24.9347 8.50107 24.9347H6.12358V23.3327H8.17791C8.56262 23.3327 8.87962 23.2666 9.12891 23.1342C9.38127 22.9988 9.56901 22.8126 9.69212 22.5756C9.8183 22.3356 9.88139 22.0601 9.88139 21.7493C9.88139 21.4354 9.8183 21.1615 9.69212 20.9276C9.56901 20.6906 9.38127 20.5075 9.12891 20.3782C8.87654 20.2459 8.55646 20.1797 8.16868 20.1797H6.82067V28H4.82173ZM16.0703 28H12.7187V18.5455H16.098C17.049 18.5455 17.8676 18.7347 18.554 19.1133C19.2403 19.4888 19.7681 20.0289 20.1374 20.7337C20.5098 21.4384 20.696 22.2817 20.696 23.2635C20.696 24.2483 20.5098 25.0947 20.1374 25.8026C19.7681 26.5104 19.2372 27.0536 18.5447 27.4322C17.8553 27.8107 17.0305 28 16.0703 28ZM14.7177 26.2873H15.9872C16.5781 26.2873 17.0751 26.1826 17.4783 25.9734C17.8846 25.761 18.1893 25.4332 18.3924 24.9901C18.5986 24.5438 18.7017 23.9683 18.7017 23.2635C18.7017 22.5649 18.5986 21.994 18.3924 21.5508C18.1893 21.1076 17.8861 20.7814 17.4829 20.5721C17.0798 20.3628 16.5827 20.2582 15.9918 20.2582H14.7177V26.2873ZM21.6567 28V18.5455H27.9167V20.1935H23.6557V22.4464H27.5012V24.0945H23.6557V28H21.6567Z" fill="#343434"/> <path d="M16.6663 14.6667H10.6663M21.333 9.33342H10.6663M26.6663 16.0001V9.06675C26.6663 6.82654 26.6663 5.70643 26.2304 4.85079C25.8469 4.09814 25.235 3.48622 24.4823 3.10272C23.6267 2.66675 22.5066 2.66675 20.2663 2.66675H11.733C9.4928 2.66675 8.37269 2.66675 7.51705 3.10272C6.7644 3.48622 6.15248 4.09814 5.76898 4.85079C5.33301 5.70643 5.33301 6.82654 5.33301 9.06675V16.0001" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
            }
            if(type == 'office'){
                var extension = this.extension
                if(extension == 'ppt' || extension == 'pptx'){
                    return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M4.82173 28V18.5455H8.55185C9.26894 18.5455 9.87985 18.6824 10.3846 18.9563C10.8893 19.2272 11.274 19.6042 11.5387 20.0874C11.8065 20.5675 11.9403 21.1214 11.9403 21.7493C11.9403 22.3771 11.8049 22.9311 11.5341 23.4112C11.2633 23.8913 10.8709 24.2653 10.3569 24.533C9.846 24.8008 9.22739 24.9347 8.50107 24.9347H6.12358V23.3327H8.17791C8.56262 23.3327 8.87962 23.2666 9.12891 23.1342C9.38127 22.9988 9.56901 22.8126 9.69212 22.5756C9.8183 22.3356 9.88139 22.0601 9.88139 21.7493C9.88139 21.4354 9.8183 21.1615 9.69212 20.9276C9.56901 20.6906 9.38127 20.5075 9.12891 20.3782C8.87654 20.2459 8.55646 20.1797 8.16868 20.1797H6.82067V28H4.82173ZM12.7187 28V18.5455H16.4488C17.1659 18.5455 17.7768 18.6824 18.2816 18.9563C18.7863 19.2272 19.171 19.6042 19.4357 20.0874C19.7035 20.5675 19.8373 21.1214 19.8373 21.7493C19.8373 22.3771 19.7019 22.9311 19.4311 23.4112C19.1603 23.8913 18.7678 24.2653 18.2539 24.533C17.743 24.8008 17.1244 24.9347 16.3981 24.9347H14.0206V23.3327H16.0749C16.4596 23.3327 16.7766 23.2666 17.0259 23.1342C17.2783 22.9988 17.466 22.8126 17.5891 22.5756C17.7153 22.3356 17.7784 22.0601 17.7784 21.7493C17.7784 21.4354 17.7153 21.1615 17.5891 20.9276C17.466 20.6906 17.2783 20.5075 17.0259 20.3782C16.7735 20.2459 16.4535 20.1797 16.0657 20.1797H14.7177V28H12.7187ZM20.2556 20.1935V18.5455H28.0205V20.1935H25.126V28H23.1502V20.1935H20.2556Z" fill="#343434"/><path d="M16.6663 14.6667H10.6663M21.333 9.33342H10.6663M26.6663 16.0001V9.06675C26.6663 6.82654 26.6663 5.70643 26.2304 4.85079C25.8469 4.09814 25.235 3.48622 24.4823 3.10272C23.6267 2.66675 22.5066 2.66675 20.2663 2.66675H11.733C9.4928 2.66675 8.37269 2.66675 7.51705 3.10272C6.7644 3.48622 6.15248 4.09814 5.76898 4.85079C5.33301 5.70643 5.33301 6.82654 5.33301 9.06675V16.0001" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                }else if(extension == 'xls' || extension == 'xlsx'){
                    return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M6.69602 18.5455L8.60263 21.7678H8.67649L10.5923 18.5455H12.8498L9.96449 23.2727L12.9144 28H10.6154L8.67649 24.7731H8.60263L6.66371 28H4.37393L7.3331 23.2727L4.42933 18.5455H6.69602ZM13.5947 28V18.5455H15.5936V26.3519H19.6469V28H13.5947ZM25.5796 21.2646C25.5427 20.8922 25.3842 20.6029 25.1041 20.3967C24.824 20.1905 24.4439 20.0874 23.9638 20.0874C23.6376 20.0874 23.3621 20.1335 23.1375 20.2259C22.9128 20.3151 22.7405 20.4397 22.6204 20.5998C22.5035 20.7598 22.445 20.9414 22.445 21.1445C22.4388 21.3138 22.4742 21.4615 22.5512 21.5877C22.6312 21.7139 22.7405 21.8232 22.8789 21.9155C23.0174 22.0047 23.1775 22.0832 23.3591 22.1509C23.5406 22.2156 23.7345 22.271 23.9407 22.3171L24.7902 22.5202C25.2026 22.6126 25.5811 22.7357 25.9258 22.8896C26.2705 23.0434 26.569 23.2327 26.8214 23.4574C27.0738 23.6821 27.2692 23.9467 27.4077 24.2514C27.5493 24.5561 27.6216 24.9054 27.6247 25.2994C27.6216 25.878 27.4739 26.3796 27.1815 26.8043C26.8922 27.226 26.4736 27.5537 25.9258 27.7876C25.3811 28.0185 24.724 28.1339 23.9546 28.1339C23.1913 28.1339 22.5266 28.0169 21.9603 27.783C21.3971 27.5491 20.957 27.2029 20.64 26.7443C20.326 26.2827 20.1614 25.7118 20.146 25.0316H22.0803C22.1018 25.3486 22.1926 25.6133 22.3527 25.8256C22.5158 26.0349 22.7328 26.1934 23.0036 26.3011C23.2775 26.4058 23.5868 26.4581 23.9315 26.4581C24.27 26.4581 24.564 26.4089 24.8132 26.3104C25.0656 26.2119 25.261 26.0749 25.3995 25.8995C25.538 25.7241 25.6073 25.5225 25.6073 25.2947C25.6073 25.0824 25.5442 24.9039 25.418 24.7592C25.2949 24.6146 25.1133 24.4915 24.8733 24.3899C24.6363 24.2884 24.3454 24.196 24.0007 24.1129L22.9713 23.8544C22.1742 23.6605 21.5448 23.3574 21.0831 22.945C20.6215 22.5326 20.3922 21.977 20.3953 21.2784C20.3922 20.706 20.5445 20.2058 20.8523 19.7781C21.1632 19.3503 21.5894 19.0163 22.1311 18.7763C22.6727 18.5362 23.2883 18.4162 23.9777 18.4162C24.6794 18.4162 25.2918 18.5362 25.815 18.7763C26.3413 19.0163 26.7506 19.3503 27.043 19.7781C27.3354 20.2058 27.4862 20.7013 27.4954 21.2646H25.5796Z" fill="#343434"/><path d="M16.6663 14.6667H10.6663M21.333 9.33342H10.6663M26.6663 16.0001V9.06675C26.6663 6.82654 26.6663 5.70643 26.2304 4.85079C25.8469 4.09814 25.235 3.48622 24.4823 3.10272C23.6267 2.66675 22.5066 2.66675 20.2663 2.66675H11.733C9.4928 2.66675 8.37269 2.66675 7.51705 3.10272C6.7644 3.48622 6.15248 4.09814 5.76898 4.85079C5.33301 5.70643 5.33301 6.82654 5.33301 9.06675V16.0001" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                }else
                    return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M6.1733 28H2.82173V18.5455H6.20099C7.15199 18.5455 7.97064 18.7347 8.65696 19.1133C9.34328 19.4888 9.87109 20.0289 10.2404 20.7337C10.6128 21.4384 10.799 22.2817 10.799 23.2635C10.799 24.2483 10.6128 25.0947 10.2404 25.8026C9.87109 26.5104 9.3402 27.0536 8.64773 27.4322C7.95833 27.8107 7.13352 28 6.1733 28ZM4.82067 26.2873H6.0902C6.68111 26.2873 7.17815 26.1826 7.58132 25.9734C7.98757 25.761 8.29226 25.4332 8.49538 24.9901C8.70159 24.5438 8.80469 23.9683 8.80469 23.2635C8.80469 22.5649 8.70159 21.994 8.49538 21.5508C8.29226 21.1076 7.98911 20.7814 7.58594 20.5721C7.18277 20.3628 6.68572 20.2582 6.09482 20.2582H4.82067V26.2873ZM20.448 23.2727C20.448 24.3037 20.2525 25.1809 19.8617 25.9041C19.4739 26.6274 18.9445 27.1798 18.2736 27.5614C17.6057 27.94 16.8548 28.1293 16.0207 28.1293C15.1806 28.1293 14.4265 27.9384 13.7587 27.5568C13.0908 27.1752 12.563 26.6228 12.1752 25.8995C11.7874 25.1763 11.5935 24.3007 11.5935 23.2727C11.5935 22.2417 11.7874 21.3646 12.1752 20.6413C12.563 19.9181 13.0908 19.3672 13.7587 18.9886C14.4265 18.607 15.1806 18.4162 16.0207 18.4162C16.8548 18.4162 17.6057 18.607 18.2736 18.9886C18.9445 19.3672 19.4739 19.9181 19.8617 20.6413C20.2525 21.3646 20.448 22.2417 20.448 23.2727ZM18.4213 23.2727C18.4213 22.6049 18.3213 22.0417 18.1212 21.5831C17.9243 21.1245 17.6457 20.7768 17.2857 20.5398C16.9256 20.3028 16.5039 20.1843 16.0207 20.1843C15.5376 20.1843 15.1159 20.3028 14.7558 20.5398C14.3957 20.7768 14.1157 21.1245 13.9156 21.5831C13.7187 22.0417 13.6202 22.6049 13.6202 23.2727C13.6202 23.9406 13.7187 24.5038 13.9156 24.9624C14.1157 25.4209 14.3957 25.7687 14.7558 26.0057C15.1159 26.2427 15.5376 26.3612 16.0207 26.3612C16.5039 26.3612 16.9256 26.2427 17.2857 26.0057C17.6457 25.7687 17.9243 25.4209 18.1212 24.9624C18.3213 24.5038 18.4213 23.9406 18.4213 23.2727ZM29.7507 21.8555H27.7286C27.6917 21.5939 27.6163 21.3615 27.5024 21.1584C27.3886 20.9522 27.2424 20.7768 27.0639 20.6321C26.8854 20.4875 26.6792 20.3767 26.4453 20.2997C26.2144 20.2228 25.9636 20.1843 25.6928 20.1843C25.2034 20.1843 24.7772 20.3059 24.414 20.549C24.0508 20.7891 23.7692 21.1399 23.5692 21.6016C23.3691 22.0601 23.2691 22.6172 23.2691 23.2727C23.2691 23.9467 23.3691 24.513 23.5692 24.9716C23.7723 25.4302 24.0555 25.7764 24.4186 26.0103C24.7818 26.2442 25.2019 26.3612 25.6789 26.3612C25.9467 26.3612 26.1944 26.3258 26.4222 26.255C26.653 26.1842 26.8577 26.0811 27.0362 25.9457C27.2147 25.8072 27.3624 25.6394 27.4794 25.4425C27.5994 25.2455 27.6825 25.0208 27.7286 24.7685L29.7507 24.7777C29.6983 25.2116 29.5675 25.6302 29.3583 26.0334C29.1521 26.4335 28.8735 26.792 28.5227 27.109C28.1749 27.4229 27.7594 27.6722 27.2762 27.8569C26.7961 28.0385 26.2529 28.1293 25.6466 28.1293C24.8033 28.1293 24.0493 27.9384 23.3845 27.5568C22.7228 27.1752 22.1996 26.6228 21.8149 25.8995C21.4333 25.1763 21.2425 24.3007 21.2425 23.2727C21.2425 22.2417 21.4364 21.3646 21.8242 20.6413C22.212 19.9181 22.7382 19.3672 23.403 18.9886C24.0678 18.607 24.8156 18.4162 25.6466 18.4162C26.1944 18.4162 26.7022 18.4931 27.17 18.647C27.6409 18.8009 28.058 19.0256 28.4211 19.321C28.7843 19.6134 29.0797 19.9719 29.3075 20.3967C29.5383 20.8214 29.686 21.3076 29.7507 21.8555Z" fill="#343434"/><path d="M16.6663 14.6667H10.6663M21.333 9.33342H10.6663M26.6663 16.0001V9.06675C26.6663 6.82654 26.6663 5.70643 26.2304 4.85079C25.8469 4.09814 25.235 3.48622 24.4823 3.10272C23.6267 2.66675 22.5066 2.66675 20.2663 2.66675H11.733C9.4928 2.66675 8.37269 2.66675 7.51705 3.10272C6.7644 3.48622 6.15248 4.09814 5.76898 4.85079C5.33301 5.70643 5.33301 6.82654 5.33301 9.06675V16.0001" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            }
            if(type == 'eyp')
                return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M26.1203 9.625L15.4703 15.25M26.1203 9.625L20.7953 6.8125M26.1203 9.625V21M15.4703 15.25L10.1453 12.4375M15.4703 15.25V18M4.82031 9.625L15.4703 4L20.7953 6.8125M4.82031 9.625L10.1453 12.4375M4.82031 9.625V19.5M20.7953 6.8125L10.1453 12.4375" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.82173 28V18.5455H10.1925V20.1935H5.82067V22.4464H9.8647V24.0945H5.82067V26.3519H10.2109V28H3.82173ZM10.7077 18.5455H12.9467L15.1026 22.6172H15.1949L17.3508 18.5455H19.5898L16.1413 24.6577V28H14.1562V24.6577L10.7077 18.5455ZM20.1616 28V18.5455H23.8917C24.6088 18.5455 25.2197 18.6824 25.7245 18.9563C26.2292 19.2272 26.6139 19.6042 26.8786 20.0874C27.1463 20.5675 27.2802 21.1214 27.2802 21.7493C27.2802 22.3771 27.1448 22.9311 26.874 23.4112C26.6031 23.8913 26.2107 24.2653 25.6968 24.533C25.1859 24.8008 24.5673 24.9347 23.8409 24.9347H21.4635V23.3327H23.5178C23.9025 23.3327 24.2195 23.2666 24.4688 23.1342C24.7212 22.9988 24.9089 22.8126 25.032 22.5756C25.1582 22.3356 25.2213 22.0601 25.2213 21.7493C25.2213 21.4354 25.1582 21.1615 25.032 20.9276C24.9089 20.6906 24.7212 20.5075 24.4688 20.3782C24.2164 20.2459 23.8963 20.1797 23.5086 20.1797H22.1605V28H20.1616Z" fill="#343434"/></svg>'
            if(type == 'code')
                return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M4.69602 18.5455L6.60263 21.7678H6.67649L8.59233 18.5455H10.8498L7.96449 23.2727L10.9144 28H8.61541L6.67649 24.7731H6.60263L4.66371 28H2.37393L5.3331 23.2727L2.42933 18.5455H4.69602ZM11.5947 18.5455H14.0599L16.6636 24.8977H16.7744L19.3781 18.5455H21.8433V28H19.9044V21.8462H19.8259L17.3791 27.9538H16.0588L13.6121 21.8232H13.5336V28H11.5947V18.5455ZM22.9702 28V18.5455H24.9691V26.3519H29.0224V28H22.9702Z" fill="#343434"/><path d="M16.6663 14.6667H10.6663M21.333 9.33342H10.6663M26.6663 16.0001V9.06675C26.6663 6.82654 26.6663 5.70643 26.2304 4.85079C25.8469 4.09814 25.235 3.48622 24.4823 3.10272C23.6267 2.66675 22.5066 2.66675 20.2663 2.66675H11.733C9.4928 2.66675 8.37269 2.66675 7.51705 3.10272C6.7644 3.48622 6.15248 4.09814 5.76898 4.85079C5.33301 5.70643 5.33301 6.82654 5.33301 9.06675V16.0001" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            if(type == 'text')
                return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"> <path d="M3.46165 20.1935V18.5455H11.2266V20.1935H8.33203V28H6.35618V20.1935H3.46165ZM13.8596 18.5455L15.7662 21.7678H15.8401L17.7559 18.5455H20.0134L17.1281 23.2727L20.078 28H17.779L15.8401 24.7731H15.7662L13.8273 28H11.5375L14.4967 23.2727L11.5929 18.5455H13.8596ZM20.3982 20.1935V18.5455H28.1631V20.1935H25.2686V28H23.2927V20.1935H20.3982Z" fill="#343434"/> <path d="M16.6663 14.6667H10.6663M21.333 9.33342H10.6663M26.6663 16.0001V9.06675C26.6663 6.82654 26.6663 5.70643 26.2304 4.85079C25.8469 4.09814 25.235 3.48622 24.4823 3.10272C23.6267 2.66675 22.5066 2.66675 20.2663 2.66675H11.733C9.4928 2.66675 8.37269 2.66675 7.51705 3.10272C6.7644 3.48622 6.15248 4.09814 5.76898 4.85079C5.33301 5.70643 5.33301 6.82654 5.33301 9.06675V16.0001" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            if(type == 'image')
                return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M6.82067 18.5455V28H4.82173V18.5455H6.82067ZM7.94529 18.5455H10.4105L13.0142 24.8977H13.125L15.7287 18.5455H18.1939V28H16.2549V21.8462H16.1765L13.7297 27.9538H12.4094L9.96269 21.8232H9.88421V28H7.94529V18.5455ZM25.59 21.6016C25.5253 21.3769 25.4346 21.1784 25.3176 21.006C25.2006 20.8306 25.0575 20.6829 24.8883 20.5629C24.7221 20.4397 24.5313 20.3459 24.3158 20.2812C24.1035 20.2166 23.868 20.1843 23.6095 20.1843C23.1263 20.1843 22.7016 20.3043 22.3354 20.5444C21.9722 20.7844 21.689 21.1338 21.4859 21.5923C21.2828 22.0478 21.1812 22.6049 21.1812 23.2635C21.1812 23.9221 21.2813 24.4822 21.4813 24.9439C21.6814 25.4055 21.9645 25.7579 22.3307 26.0011C22.697 26.2411 23.1294 26.3612 23.628 26.3612C24.0804 26.3612 24.4666 26.2811 24.7867 26.1211C25.1099 25.958 25.3561 25.7287 25.5253 25.4332C25.6977 25.1378 25.7839 24.7885 25.7839 24.3853L26.1901 24.4453H23.7526V22.9403H27.7089V24.1314C27.7089 24.9624 27.5335 25.6764 27.1827 26.2734C26.8318 26.8674 26.3486 27.326 25.7331 27.6491C25.1176 27.9692 24.4128 28.1293 23.6187 28.1293C22.7324 28.1293 21.9537 27.9338 21.2828 27.543C20.6119 27.149 20.0887 26.5904 19.7132 25.8672C19.3408 25.1409 19.1546 24.2791 19.1546 23.282C19.1546 22.5156 19.2654 21.8324 19.487 21.2322C19.7117 20.629 20.0256 20.1181 20.4288 19.6996C20.8319 19.281 21.3013 18.9625 21.8368 18.744C22.3723 18.5254 22.9524 18.4162 23.5772 18.4162C24.1127 18.4162 24.6113 18.4947 25.0729 18.6516C25.5346 18.8055 25.9439 19.024 26.3009 19.3072C26.661 19.5903 26.9549 19.9273 27.1827 20.3182C27.4104 20.706 27.5566 21.1338 27.6212 21.6016H25.59Z" fill="#343434"/><path d="M16.6663 14.6667H10.6663M21.333 9.33342H10.6663M26.6663 16.0001V9.06675C26.6663 6.82654 26.6663 5.70643 26.2304 4.85079C25.8469 4.09814 25.235 3.48622 24.4823 3.10272C23.6267 2.66675 22.5066 2.66675 20.2663 2.66675H11.733C9.4928 2.66675 8.37269 2.66675 7.51705 3.10272C6.7644 3.48622 6.15248 4.09814 5.76898 4.85079C5.33301 5.70643 5.33301 6.82654 5.33301 9.06675V16.0001" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            if(type == '')
                return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><g clip-path="url(#clip0_26_803)"><path d="M18.6663 14.6667H10.6663M13.333 20.0001H10.6663M21.333 9.33341H10.6663M26.6663 9.06675V22.9334C26.6663 25.1736 26.6663 26.2937 26.2304 27.1494C25.8469 27.902 25.235 28.5139 24.4823 28.8974C23.6267 29.3334 22.5066 29.3334 20.2663 29.3334H11.733C9.4928 29.3334 8.37269 29.3334 7.51705 28.8974C6.7644 28.5139 6.15248 27.902 5.76898 27.1494C5.33301 26.2937 5.33301 25.1736 5.33301 22.9334V9.06675C5.33301 6.82654 5.33301 5.70643 5.76898 4.85079C6.15248 4.09814 6.7644 3.48622 7.51705 3.10272C8.37269 2.66675 9.4928 2.66675 11.733 2.66675H20.2663C22.5066 2.66675 23.6267 2.66675 24.4823 3.10272C25.235 3.48622 25.8469 4.09814 26.2304 4.85079C26.6663 5.70643 26.6663 6.82654 26.6663 9.06675Z" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_26_803"><rect width="32" height="32" fill="white"/></clipPath></defs></svg>'
        },
        showContextMenu(){
            this.isContextMenuVisible = true;
        },
        hideContextMenu(){
            if(this.disableFocusOut) {
                this.disableFocusOut = false;
                return;
            }

            this.isContextMenuVisible = false;

            //var scp = this;
            //setTimeout(function(){ scp.isContextMenuVisible = false; }, 50);
        },
        sheetItemClick(item) {
            this.sheetOpen = false;
            this.menuItemClick(item.event, this.document, item.arg1, item.arg2, item.arg3);
        },
        menuItemClick(event, param1, param2, param3, param4) {
            this.$emit(event, param1, param2, param3, param4);
            this.isContextMenuVisible = false;
        }
    },
    computed: {
        // Alttan açılan menü seçenekleri (eski açılır menüdekilerle aynı koşullar)
        menuItems(){
            var items = [];
            if(this.canDownload)
                items.push({ label: 'Orijinal Dosyayı İndir', icon: 'download', event: 'download', arg1: 'download' });
            if(this.hasSignedVersion && this.canDownload)
                items.push({ label: 'İmzalı Versiyonu İndir', icon: 'draw', event: 'download', arg1: 'downloadSigned' });
            if(this.hasFormattedVersion && this.canDownload)
                items.push({ label: 'Excel Formatında İndir', icon: 'table_chart', event: 'download', arg1: 'downloadFormatted' });
            if(this.isEYP)
                items.push({ label: 'EYP paketi görüntüle', icon: 'visibility', event: 'preview', arg1: 'eyp' });
            if(this.isOffice)
                items.push({ label: 'Dokümanı görüntüle', icon: 'visibility', event: 'preview', arg1: 'office' });
            if(this.isText)
                items.push({ label: 'Metin Belgesini görüntüle', icon: 'visibility', event: 'preview', arg1: 'text' });
            if(this.isCode)
                items.push({ label: 'XML Dosyasını görüntüle', icon: 'visibility', event: 'preview', arg1: 'code' });
            if(this.isPdf)
                items.push({ label: 'Dokümanı görüntüle', icon: 'visibility', event: 'preview', arg1: 'pdf', arg2: false, arg3: true });
            if(this.isImage)
                items.push({ label: 'Resmi görüntüle', icon: 'visibility', event: 'preview', arg1: 'image' });
            return items;
        },
        iconName(){
            var type = this.getType;
            if(type == 'pdf')
                return 'picture_as_pdf';
            if(type == 'image')
                return 'image';
            if(type == 'eyp')
                return 'folder_zip';
            if(['xls', 'xlsx'].indexOf(this.extension) > -1)
                return 'table_chart';
            return 'description';
        },
        canDownload(){
            return window.settings.allowFileDownload ?? true;
        },
        canPreview(){
            console.log("isOnlineView:",this.isOnlineView)
            console.log("isActive:",this.isActive)
            console.log("getType:",this.getType)
            if(!this.isActive)
                return false;
            if(this.getType == '')
                return false;
            if(!this.isOnlineView){
                if(this.getType == 'office')
                    return false;
            }
            return true;
        },
        cannotPreview(){
            if(!this.isActive)
                return false;
            if(this.getType == '')
                return true;
            if(!this.isOnlineView){
                if(this.getType == 'office' )
                    return true;
            }
            return false;
        },
        getType(){
            if(this.isText && this.isDocumentFormat){
                return 'office'
            }
            if(this.isPdf)
                return 'pdf'
            if(this.isOffice)
                return 'office'
            if(this.isEYP)
                return 'eyp'
            if(this.isCode)
                return 'code'
            if(this.isText)
                return 'text'
            if(this.isImage)
                return 'image'
            return ''
        },
        fileName(){
            return this.document.FileName || this.document.UnsignedFile.FileName;
        },
        extension(){
            return this.fileName.split('.').reverse()[0].toLowerCase();
        },
        size(){
            return this.document?.Size || this.document.UnsignedFile?.Size || 0;
        },
        hasSignedVersion(){
            return !!this.document.SignedFile;
        },
        isEYP(){
            return this.document.SignatureFormat == 'EYP' || this.document.SignatureFormat == 'EYP2' || this.document.Extension == '.eyp' || ['eyp'].indexOf(this.extension) > -1;
        },
        isOffice(){
            if(this.isDocumentFormat && this.isText){
                return true
            }
            return ['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx'].indexOf(this.extension) > -1;
        },
        isCode(){
            return ['xml'].indexOf(this.extension) > -1;
        },
        isText(){
            return ['txt'].indexOf(this.extension) > -1;
        },
        isPdf(){
            //return false;
            return ['pdf'].indexOf(this.extension) > -1 ;
            // Bu özellik şimdilik devre dışı. PDF'i iframe içinde görüntülemek istediğimizde dosya olarak indiriyor.
            //return this.extension == 'pdf';
        },
        isImage(){
            return this.size < 5 * 1024 * 1024
                && ['jpeg', 'jpg', 'png', 'svg'].indexOf(this.extension) > -1;
        },
        isOffice365(){
            return this.size < 5 * 1024 * 1024
                && ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pps', 'sldx', 'xps', 'txt', 'rtf'].indexOf(this.extension) > -1;
        },
        isGoogleDocs(){
            return this.size < 5 * 1024 * 1024
                && ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pps', 'sldx', 'xps', 'txt', 'rtf', 'jpeg', 'jpg', 'png', 'gif', 'bmp', 'mpeg4', '3gpp', 'mov', 'avi', 'wmv', 'mpegps', 'flv', 'html', 'pages', 'ai', 'psd', 'tiff', 'dxf', 'svg', 'ttf', 'xps', 'zip', 'rar'].indexOf(this.extension) > -1;
        },
        hasFormattedVersion(){
            return this.isDocumentFormat && this.isText;
        }
    }
}
</script>
<style scoped>
.focus-object {
    width:0px;
    height: 0px;
    border:0;
    outline:none;
    opacity: 0;
    position: absolute;
}
.download-signed-button-container{
    width: 100% ;
    height: 35px;
    flex-direction: row;
}
.download-signed-button-container button{
    min-width: 100px;
}
.btn-info,.btn-outline-secondary, .btn-primary{
    font-size: small;
}

.fileName{
    word-break: break-all;
}

/* Voya satır görünümü */
.fdl-row {
    display: flex;
    align-items: center;
    gap: 10px;
    box-sizing: border-box;
    min-height: 50px;
    padding: 8px 6px 8px 10px;
    border: 1px solid #DCE3F2;
    border-radius: 10px;
    background-color: #F1F7FF;
    font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
}

.fdl-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: #ffffff;
    font-size: 20px;
    color: #182F5E;
}

.fdl-main {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.fdl-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #333333 !important;
    text-decoration: underline !important;
}

.fdl-name-plain {
    text-decoration: none !important;
}

.fdl-size {
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #808080;
}

.fdl-menu-btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: #182F5E;
    font-size: 22px;
}

.fdl-menu-btn:active {
    background-color: rgba(9, 33, 84, 0.08);
}

.fdl-sheet-item {
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    height: 52px;
    padding: 0 8px;
    border: none;
    border-radius: 10px;
    background: transparent;
    text-align: left;
    font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 15px;
    color: #092154;
}

.fdl-sheet-item:active {
    background-color: #F4F6FA;
}

.fdl-sheet-item .material-symbols-outlined {
    font-size: 22px;
    color: #182F5E;
}
/* Çoklu görüntüleyicideki dosya listesi satırı (customStyle) */
.customStyle{
    display: flex;
    align-items: center;
    gap: 10px;
    box-sizing: border-box;
    min-height: 48px;
    padding: 8px 12px;
    border-radius: 10px;
    background-color: transparent;
    font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #333333 !important;
    transition: 0.2s ease-in-out;
    text-decoration: none !important;
    word-break: break-all;
    border: 1px solid transparent;
}
.customStyle:active{
    cursor: pointer;
    background-color: #F4F6FA;
}
.isPreviewing{
    border: 1px solid #DCE3F2;
    background-color: #F1F7FF;
    font-weight: 600;
    color: #092154 !important;
}
</style>